import { ref } from 'vue';
import handleProjects from "@/services/modules/procurement/project";

const projects = ref([]);
const isFetching = ref(false);
let fetchPromise = null;

export function useSharedProjectList() {
    const { fetchProjects } = handleProjects();

    const getProjects = async (query) => {
        if (projects.value.length > 0) {
            return { status: true, data: projects.value };
        }
        
        if (isFetching.value) {
            return fetchPromise;
        }

        isFetching.value = true;
        fetchPromise = fetchProjects(query);
        
        try {
            const res = await fetchPromise;
            if (res.status) {
                projects.value = res.data;
            }
            return res;
        } finally {
            isFetching.value = false;
            fetchPromise = null;
        }
    };

    return {
        projects,
        getProjects,
        isFetching
    };
}
